import { Box, Button, Paper } from '@mui/material'
import { getBasketTotal } from '../../context/AppReducer'
import { useAuth } from '../../context/GlobalState'

import CurrencyFormat from 'react-currency-format'
import { useNavigate } from 'react-router-dom';

export default function Subtotal() {
    const {basket , user} = useAuth();
    const navigate = useNavigate();
  return (
    <Box sx={{bgcolor:"#eee" , border:"1px solid #999" ,
        px:{sm:14 , xs:10} ,py:1,
        textAlign:"center",
        borderRadius:"8px"
        , display:"flex",
        flexDirection:"column",
        gap:1
        }}>

    <CurrencyFormat
        renderText={(value) => (
          <>
            <p>
              Sub Total ({basket.length} items): <strong>{value}</strong>
            </p>
            <small >
              <input type="checkbox"/> This Order Contains A Gift
            </small>
          </>
        )}
        decimalScale={2}
        value={getBasketTotal(basket)}
        displayType={"text"}
        thousandSeparator={true}
        prefix={"$"}
      />
      <Button variant='contained' 
      sx={{bgcolor:"#fcd115" ,color:"#222" , my:1 , width:"100%"}}
      onClick={()=>{
        user? navigate("/payment"):navigate("/login")
      }}
      >
        Proceed To Checkout
    </Button>
    </Box>

  )
}
